import { render } from "./ApplicantNavbar.vue?vue&type=template&id=545309ea&scoped=true"
const script = {}

import "./ApplicantNavbar.vue?vue&type=style&index=0&id=545309ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545309ea"]])

export default __exports__